import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
import { handleApiError } from '@porterin/component-library/src/ts-utils/analytics/sentry/SentryHelpers';
import { getCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import axios from 'axios';

import {
  PartloadServiceabilityRequest,
  PartloadServiceabilityResponse,
} from '../api-models/PartloadServiceabilityApiModel';

const Config: AppConfig = getAppConfig();

const SERVICEABILITY_URL = `${Config.wag_url}/partload/booking/check_serviceability`;

export async function checkPartloadServiceability(
  pickupLat: number,
  pickupLng: number,
  dropLat: number,
  dropLng: number,
  customerMobile: string,
): Promise<boolean> {
  try {
    const payload: PartloadServiceabilityRequest = {
      pickup: { lat: pickupLat, lng: pickupLng },
      drop: { lat: dropLat, lng: dropLng },
      customer_mobile: customerMobile,
      waypoints: null,
    };

    const response = await axios.post<PartloadServiceabilityResponse>(
      SERVICEABILITY_URL,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'visitor-id': getCookie('visitor_id') ?? null,
        },
      },
    );

    return response.data.is_serviceable;
  } catch (error: unknown) {
    handleApiError(error, 'checkPartloadServiceability');
    return false;
  }
}
